import { VA_FORM_IDS } from '@department-of-veterans-affairs/platform-forms/constants';
// TODO(software/va.gov-team#155881): trackAction/getTrackingDefaults/get0781TrackingDefaults
// are generic 526EZ RUM tracking infra still owned by all-claims (used by 18+ files there),
// so it wasn't relocated in the form0781/all-claims decoupling. Move this into shared once
// that ticket lands so this file has no remaining all-claims import.
import {
  get0781TrackingDefaults,
  getTrackingDefaults,
  trackAction,
} from '../../../../shared/utils/tracking/datadogRumTracking';

export const WORKFLOW_CHOICE_MODAL_TYPES = Object.freeze({
  DELETE_ONLINE_INFORMATION: 'delete_online_information',
  DELETE_UPLOADED_PDF: 'delete_uploaded_pdf',
});

export const WORKFLOW_CHOICE_MODAL_TRIGGER_TYPES = Object.freeze({
  SIDENAV: 'sidenav',
  CONTINUE: 'continue',
});

export const WORKFLOW_CHOICE_MODAL_ACTIONS = Object.freeze({
  CONFIRM: 'confirm',
  CANCEL: 'cancel',
});

/**
 * Builds a shared payload for 0781 workflow choice tracking events.
 * Includes source path and optional tracking defaults when available.
 *
 * @param {object} properties Event-specific properties.
 * @returns {object} Tracking payload with shared and event-specific fields.
 */
const withSharedProperties = properties => {
  const { sourcePath, sidenav526ezEnabled } = getTrackingDefaults();
  const { syncModern0781Flow } = get0781TrackingDefaults();

  const payload = {
    formId: VA_FORM_IDS.FORM_21_526EZ,
    sourcePath,
    ...properties,
  };

  if (syncModern0781Flow !== undefined) {
    payload.syncModern0781Flow = syncModern0781Flow;
  }

  if (sidenav526ezEnabled !== undefined) {
    payload.sidenav526ezEnabled = sidenav526ezEnabled;
  }

  return payload;
};

/**
 * Tracks when the 0781 workflow choice page is rendered.
 */
export const trackWorkflowChoicePageRendered = () => {
  trackAction(
    '21-526EZ_0781WorkflowChoicePageRendered',
    withSharedProperties({}),
  );
};

/**
 * Tracks when the destructive confirmation modal is rendered.
 *
 * @param {object} params
 * @param {string} params.modalType Type of data being deleted.
 * @param {string} params.triggerType Origin of the modal trigger (side nav or continue).
 */
export const trackWorkflowChoiceDestructiveModalRendered = ({
  modalType,
  triggerType,
}) => {
  trackAction(
    '21-526EZ_0781WorkflowChoiceDestructiveModalRendered',
    withSharedProperties({
      modalType,
      triggerType,
    }),
  );
};

/**
 * Tracks user action taken on the destructive confirmation modal.
 *
 * @param {object} params
 * @param {string} params.modalType Type of data being deleted.
 * @param {string} params.triggerType Origin of the modal trigger (side nav or continue).
 * @param {string} params.action User action on the modal (confirm or cancel).
 */
export const trackWorkflowChoiceDestructiveModalAction = ({
  modalType,
  triggerType,
  action,
}) => {
  trackAction(
    '21-526EZ_0781WorkflowChoiceDestructiveModalActionTaken',
    withSharedProperties({
      modalType,
      triggerType,
      action,
    }),
  );
};

/**
 * Tracks when the post-confirmation success alert is rendered.
 *
 * @param {object} params
 * @param {string} params.alertType Type of success alert shown.
 * @param {boolean} params.triggeredBySidenav Whether the alert followed a side-nav-triggered modal.
 */
export const trackWorkflowChoiceSuccessAlertRendered = ({
  alertType,
  triggeredBySidenav,
}) => {
  trackAction(
    '21-526EZ_0781WorkflowChoiceSuccessAlertRendered',
    withSharedProperties({
      alertType,
      triggeredBySidenav,
    }),
  );
};
